import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useId, useState } from "react";
import trans, { isRTL } from "../../../../utils";
import { toast } from "react-toastify";
import { InputDate, TextAreaInput } from "../../../Helpers/Input/Input";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import FileUploader from "../../../Helpers/Dropzone/FileUploader";
import Button from "../../../Helpers/Button/Button";
import { editData, storeData } from "../../../../utils/IndexedDB";
import Popup from "../../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import { Tag } from "antd";
import AntUpload from "../../../FormBuilderInputs/Upload";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

export default function IROfflineQA({
	deficienciesLen,
	setQAAction,
	refetch,
	setIRId,
	irId,
	setAction,
}) {
	console.log("irId?.id in QA", irId);
	const initialValues = {
		result: null,
		comments: null,
		deficiencies: [],
	};
	const inf = useSelector((state) => state.users.user);
	const [data, setData] = useState([]);

	const categoryQA = [
		{ label: trans("Workmanship"), value: "WORKMANSHIP" },
		{ label: trans("Dimensional"), value: "DIMENSIONAL" },
		{ label: trans("Material"), value: "MATERIAL" },
		{ label: trans("Installation"), value: "INSTALLATION" },
		{ label: trans("Documentation"), value: "DOCUMENTATION" },
		{ label: trans("Safety"), value: "SAFETY" },
		{
			label: trans("Testing & Commissioning"),
			value: "TESTING_AND_COMMISSIONING",
		},
		{ label: trans("Design/Coordination"), value: "DESIGN_COORDINATION" },
		{ label: trans("Non-Compliance"), value: "NON_COMPLIANCE" },
		{ label: trans("Incomplete/Rework"), value: "INCOMPLETE_REWORK" },
	];

	const deficiencySeverity = [
		{ label: trans("Minor"), value: "MINOR" },
		{ label: trans("Major"), value: "MAJOR" },
		{ label: trans("Critical"), value: "CRITICAL" },
	];

	const validationSchema = Yup.object({
		result: Yup.string().required(trans("Result is required")),
		comments: Yup.string().nullable(),
		deficiencies: Yup.array().of(
			Yup.object({
				category: Yup.string().nullable(),
				severity: Yup.string().nullable(),
				description: Yup.string().nullable(),
				files: Yup.array().nullable(),
			}),
		),
	});

	const addQA = useFormik({
		initialValues,
		validationSchema,
		onSubmit: async (val) => {
			try {
				if (addQA.values.result === "REJECTED") {
					const hasEmptyFields = data.some(
						(i) => !i.category || !i.severity || !i.description,
					);

					if (hasEmptyFields) {
						toast.error(trans("Please fill all deficiency data"), {
							autoClose: 800,
							rtl: localStorage.getItem("lang") === "ar",
						});
						return;
					}
					await storeData("OfflineModeData", "IRQA", irId?.id, {
						id: irId?.id,
						uid: irId?.uid,
						userId11: inf?.id,
						comments: val.comments,
						result: val.result,
						deficiencies: data,
						configurationName: irId?.configurationName,
						project_name: irId?.project?.name,
						zone_name: irId?.zone?.name,
						level_name: irId?.level?.name,
						room_name: irId?.room?.name,
						type: irId?.type,
						statusSync: "Pending Sync",
					});
					await editData("OfflineModeData", "IR", irId?.id, {
						...irId,
						statusSync: "Pending Sync",
					});
					setAction(true);

					// Submit with FormData
					setQAAction(false);
					setIRId(null);
					toast.success(trans("IR QA Review Submitted Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar",
					});
				} else {
					// For APPROVED, send regular JSON
					await storeData("OfflineModeData", "IRQA", irId?.id, {
						configurationName: irId?.configurationName,
						project_name: irId?.project?.name,
						zone_name: irId?.zone?.name,
						level_name: irId?.level?.name,
						room_name: irId?.room?.name,
						type: irId?.type,
						uid: irId?.uid,
						statusSync: "Pending Sync",
						...val,
					});
					await editData("OfflineModeData", "IR", irId?.id, {
						...irId,
						statusSync: "Pending Sync",
					});
					setAction(true);

					toast.success(trans("IR QA Review Submitted Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar",
					});
					setQAAction(false);
					setIRId(null);
				}
			} catch (error) {
				console.log("errr", error);
			}
		},
	});

	// Handle file selection for a specific deficiency using FileUploader
	const handleFileChange = (index, files) => {
		setData((prev) =>
			prev.map((item, i) => (i === index ? { ...item, files: files } : item)),
		);
	};

	return (
		<form onSubmit={addQA.handleSubmit}>
			{/* Hide comments when deficiencies are added */}
			{data.length === 0 && (
				<TextAreaInput
					title={trans("Comments")}
					rows={3}
					placeholder={trans("Enter your comments")}
					id="comments"
					name="comments"
					value={addQA.values.comments}
					onChange={addQA.handleChange}
					onBlur={addQA.handleBlur}
					error={addQA.touched.comments && addQA.errors.comments}
				/>
			)}

			<div
				style={{
					maxHeight: "250px",
					overflowY: "scroll",
					overflowX: "none",
					marginBlock: "10px",
				}}
			>
				{data?.map((def, index) => (
					<div key={index} className="row align-items-end mb-3">
						<div className="col-lg-5">
							<InputSelect
								label={trans("Category")}
								options={categoryQA}
								placeholder={trans("Select Category")}
								value={data[index].category}
								onChange={(value) =>
									setData((prev) =>
										prev.map((item, i) =>
											i === index ? { ...item, category: value } : item,
										),
									)
								}
							/>
						</div>
						<div className="col-lg-5">
							<InputSelect
								label={trans("Severity")}
								options={deficiencySeverity}
								placeholder={trans("Select Severity")}
								value={data[index].severity}
								onChange={(value) =>
									setData((prev) =>
										prev.map((item, i) =>
											i === index ? { ...item, severity: value } : item,
										),
									)
								}
							/>
						</div>
						<div className="col-lg-10 mt-2">
							<TextAreaInput
								title={trans("Description")}
								rows={3}
								placeholder={trans("Enter description")}
								name={`deficiencies[${index}].description`}
								value={data[index].description}
								onChange={(e) =>
									setData((prev) =>
										prev.map((item, i) =>
											i === index
												? { ...item, description: e.target.value }
												: item,
										),
									)
								}
								onBlur={addQA.handleBlur}
							/>
						</div>

						{/* File Upload Section - Using FileUploader Component */}
						<div className="col-lg-10 mt-2">
							<FileUploader
								file={data[index].files || []}
								onFileSelect={(files) => handleFileChange(index, files)}
								multiple={true}
								sizeMB={5}
								label={trans("Upload Attachments")}
							/>
						</div>

						<div className="col-lg-2 mt-2 text-end">
							<Button
								type="default"
								danger
								text={trans("Remove")}
								onClick={() =>
									setData((prev) => prev.filter((_, i) => i !== index))
								}
							/>
						</div>
					</div>
				))}

				<Button
					type="dashed"
					text={trans("Add Deficiency")}
					className="mt-2"
					onClick={() =>
						setData((prev) => [
							...prev,
							{
								category: null,
								description: null,
								severity: null,
								files: [],
							},
						])
					}
				/>
			</div>

			<div className="d-flex align-items-center mt-4">
				<Button
					htmlType="submit"
					type="primary"
					text={trans("Approve")}
					onClick={() => {
						addQA.setFieldValue("result", "APPROVED");
					}}
					disabled={data?.length > 0}
					className={!isRTL ? "me-2" : "ms-2"}
				/>

				<Button
					htmlType="submit"
					danger
					text={trans("Reject")}
					onClick={() => {
						addQA.setFieldValue("result", "REJECTED");
					}}
					disabled={data?.length === 0}
				/>
				{deficienciesLen > 0 && (
					<Button
						htmlType="button"
						type="default"
						text={trans("Cancel")}
						onClick={() => setQAAction(false)}
						className={isRTL ? "me-2" : "ms-2"}
					/>
				)}
			</div>
			{addQA.touched.result && addQA.errors.result && (
				<p className="text-danger mt-2">{trans(addQA.errors.result)}</p>
			)}
		</form>
	);
}

function IROfflineQAResubmit({ setQAAction, setIRId, irId, setAction }) {
	const [submitData, setSubmitData] = useState([]);

	const initialValues = {
		correction_notes: null,
		ready_date: null,
		attachments: null,
	};
	let validSchema = Yup.object({
		ready_date: Yup.string().required(trans("Ready Date is required")),
	});
	const addForm = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val) => {
			try {
				const attachmentsItem = submitData.find(
					(item) => item.key === "attachments",
				);
				const attachments = attachmentsItem?.value || null;
				await storeData("OfflineModeData", "IRQA", irId?.id, {
					id: irId?.id,
					uid: irId?.uid,
					correction_notes: val.correction_notes,
					ready_date: val.ready_date,
					attachments: attachments,
					configurationName: irId?.configurationName,
					project_name: irId?.project?.name,
					zone_name: irId?.zone?.name,
					level_name: irId?.level?.name,
					room_name: irId?.room?.name,
					type: irId?.type,
					statusSync: "Pending Sync",
				});
				await editData("OfflineModeData", "IR", irId?.id, {
					...irId,
					statusSync: "Pending Sync",
				});
				setAction(true);

				toast.success(trans("IR Form Resubmitted Successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
				setQAAction(false);
				setIRId(null);
			} catch (error) {
				console.log("errr", error);
			}
		},
	});

	const handleSubmit = (e) => {
		e.preventDefault();
		addForm.handleSubmit(e);
	};
	console.log("addForm", addForm);
	console.log("SubmitData", submitData);
	// Create a dummy item for the uploader field
	const uploaderItem = {
		key: "attachments",
		name: "Uploader",
		title: trans("Attachments"),
		required: { value: false },
	};
	return (
		<form onSubmit={addForm.handleSubmit}>
			<TextAreaInput
				title={trans("Correction Notes")}
				rows={3}
				placeholder={trans("Enter your correction notes")}
				id="correction_notes"
				name="correction_notes"
				onChange={(e) => addForm.handleChange(e)}
				onBlur={(e) => addForm.handleBlur(e)}
				value={addForm.values.correction_notes || ""}
			/>

			<div className="mb-3">
				<InputDate
					title={trans("Ready Date")}
					id="ready_date"
					name="ready_date"
					onBlur={(value) => addForm.setFieldTouched("ready_date", true)}
					onChange={(value) => {
						const formattedDate = value
							? dayjs(value).format("YYYY-MM-DD")
							: "";
						addForm.setFieldValue("ready_date", formattedDate);
					}}
					errors={addForm.errors.ready_date}
					touched={addForm.touched.ready_date}
					value={addForm.values.ready_date || ""}
					min={dayjs(Date.now()).add(1, "day")}
				/>
			</div>

			<div className="mb-3">
				<AntUpload
					item={uploaderItem}
					readOnly={false}
					addData={addForm}
					submitData={submitData}
					setSubmitData={setSubmitData}
				/>
			</div>

			<Button
				htmlType="submit"
				type="primary"
				text={trans("Resubmit")}
				className="mt-2"
			/>
		</form>
	);
}
export function IRQAModal({ setQAAction, qaAction, setIRId, irId, setAction }) {
	return (
		<>
			<Popup show={qaAction}>
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={
								irId?.status === "PENDING_QA"
									? trans("QA Review")
									: trans("QA Resubmit Form")
							}
							subtitle={<Tag color="orange">{irId?.ir_number || ""}</Tag>}
						/>
					</Modal.Title>
					<Close
						// eslint-disable-next-line react/style-prop-object
						style="close-32 close"
						close={() => setQAAction(false)}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body className="modal-body-scrollable">
					{irId?.status === "PENDING_QA" ? (
						<IROfflineQA
							setQAAction={setQAAction}
							setIRId={setIRId}
							irId={irId}
							setAction={setAction}
						/>
					) : (
						<IROfflineQAResubmit
							setQAAction={setQAAction}
							setIRId={setIRId}
							irId={irId}
							setAction={setAction}
						/>
					)}
				</Modal.Body>
			</Popup>
		</>
	);
}
